"use client";

import { useEffect } from "react";
import { captureUTMs, persistUTMCookies } from "@/lib/utm-tracker";

/**
 * Captures UTM params from the landing URL and persists them (consent-gated)
 * so they survive navigation and reach checkout. Runs independently of the
 * in-repo cookie banner (consent is handled by the CDN SDK, which fires
 * `user_consent_changed` when the user accepts/rejects).
 */
export function UTMTrackerInit() {
  useEffect(() => {
    captureUTMs(); // URL -> sessionStorage (always)
    persistUTMCookies(); // -> cookies if advertising consent already granted

    const onConsentChange = () => persistUTMCookies();
    window.addEventListener("user_consent_changed", onConsentChange);
    return () =>
      window.removeEventListener("user_consent_changed", onConsentChange);
  }, []);

  return null;
}
